import { render } from "./MemoruUpload.vue?vue&type=template&id=d0ee43e8&ts=true"
import script from "./MemoruUpload.vue?vue&type=script&lang=ts"
export * from "./MemoruUpload.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__